import { getPresingUrl } from "../api/PresignUrlApi";
import { PresignUrl, PresignUrlRequest } from "../model/PresignUrl";
import shortId from 'short-uuid';



export async function uploadFile(file: File, newFileName: string): Promise<string> {
    var request = { file_name: getFileNameWithExtension(file, newFileName) } as PresignUrlRequest;
    var response = await getPresingUrl(request);
    let contentType = file.type == null || file.type == undefined || file.type === "" ? "text/plain" : file.type;

    const requestOptions = {
        method: "PUT",
        headers: {
            "Content-Type": contentType
        },
        body: file,
    };
    return await callExternApi(response.url, requestOptions);
}

function getFileNameWithExtension(file: File, newFileName?: string): string {
    if (newFileName && newFileName.includes(".")) {
        return newFileName;
    }
    return `${newFileName || shortId.generate()}.${file.type.split("/")[1]}`;
}

export async function callExternApi(urlPath: string, requestOptions: any): Promise<string> {
    const response = await fetch(urlPath, requestOptions);
    if (response.status === 204 || response.ok) {
        let values = urlPath.split("?");
        return Promise.resolve(values[0]);
    }
    throw new Error(await response.text());
}